// extracted by css-extract-rspack-plugin
export default {"Container":"BranchDescription-module__Container__huH1guR","ActionGroup":"BranchDescription-module__ActionGroup__KQUHi4o"};